import Carousel from '../components/product-carousel';
import { docReady } from '../utils/docReady';
import { isMobile } from '../utils/utilities';
const getCaptionsToToggle = (index, mobileCount, desktopCount, mobileCarousel, desktopCarousel, total) => {
    if (isMobile && mobileCarousel != "true") {
        let currentRow = Math.floor(index / mobileCount);
        let minIndex = currentRow * mobileCount;
        let maxIndex = minIndex + mobileCount;
        return [minIndex, maxIndex];
    }
    else if (!isMobile && desktopCarousel != "true") {
        let currentRow = Math.floor(index / desktopCount);
        let minIndex = currentRow * desktopCount;
        let maxIndex = minIndex + desktopCount;
        return [minIndex, maxIndex];
    }
    return [0, total];
};
// We had to remove the register functionality from slate as it causes conflicts with sections anywhere.
docReady(() => {
    const sections = document.querySelectorAll('[data-section-type="product-grid"]');
    if (sections.length > 0) {
        [...sections].forEach((section) => {
            const { desktopCount, mobileCount, sectionId, mobileCarousel, desktopCarousel } = section.dataset;
            const slides = parseInt(section.dataset.tiles, 10);
            if (slides > 1) {
                const swiperContainer = section.querySelector('[data-swiper-container]');
                const swiperNext = `[data-section-id="${sectionId}"] .swiper-button-next`;
                const swiperPrev = `[data-section-id="${sectionId}"] .swiper-button-prev`;
                let extraSettings = {
                    navigation: {
                        nextEl: swiperNext,
                        prevEl: swiperPrev,
                        disabledClass: 'swiper-button--disabled',
                        hiddenClass: 'swiper-button--disabled',
                    },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        hide: false,
                    },
                    mousewheel: {
                        forceToAxis: true,
                    },
                    spaceBetween: 16,
                    breakpoints: {
                        0: {
                            enabled: mobileCarousel === 'true' ? true : false,
                            slidesPerView: mobileCount
                        },
                        1023: {
                            enabled: desktopCarousel === 'true' ? true : false,
                            slidesPerView: desktopCount
                        },
                    }
                };
                const carousel = new Carousel(swiperContainer, slides, swiperNext, swiperPrev, Number(desktopCount), Number(mobileCount), extraSettings);
            }
            let captionToggles = section.querySelectorAll('[data-caption-toggle]');
            if (captionToggles.length > 0) {
                [...captionToggles].forEach((toggle, i) => {
                    toggle.addEventListener('click', (e) => {
                        e.preventDefault();
                        const caption = toggle.closest('.product-grid__product').querySelector('.product-grid__product--caption');
                        caption.classList.toggle('product-grid__product--caption-active');
                        toggle.classList.toggle('product-grid__product--caption-toggle--active');
                        if (caption.classList.contains('product-grid__product--caption-active')) {
                            let captionWrapper = toggle.closest('.product-grid__product--caption-toggle__wrapper');
                            ;
                            captionWrapper.style.marginBottom = 0 + 'px';
                        }
                        let validIndices = getCaptionsToToggle(i, Number(mobileCount), Number(desktopCount), mobileCarousel, desktopCarousel, section.dataset.tiles);
                        [...captionToggles].forEach((otherToggle, index) => {
                            if (otherToggle !== e.currentTarget && index >= validIndices[0] && index < validIndices[1]) {
                                const otherCaption = otherToggle.closest('.product-grid__product').querySelector('.product-grid__product--caption');
                                otherCaption.classList.remove('product-grid__product--caption-active');
                                otherToggle.classList.remove('product-grid__product--caption-toggle--active');
                                if (caption.classList.contains('product-grid__product--caption-active')) {
                                    let captionWrapper = otherToggle.closest('.product-grid__product--caption-toggle__wrapper');
                                    ;
                                    captionWrapper.style.marginBottom = caption.scrollHeight + 'px';
                                }
                                else if (!caption.classList.contains('product-grid__product--caption-active')) {
                                    let captionWrapper = otherToggle.closest('.product-grid__product--caption-toggle__wrapper');
                                    ;
                                    captionWrapper.style.marginBottom = '0px';
                                }
                            }
                        });
                    });
                });
            }
            let stickyHeader = section.querySelector('.product-grid__text-container');
            let stickyHeaderClone = section.querySelector('.product-grid__text-container__clone');
            if (stickyHeaderClone) {
                window.addEventListener('scroll', () => {
                    let title = section.querySelector('.product-grid__title');
                    let subheader = section.querySelector('.product-grid__pre-heading');
                    let stickyHeaderTop = (title.offsetTop - 24 + (subheader ? 44 : 0)) - (stickyHeader.offsetHeight);
                    if (isMobile) {
                        stickyHeaderTop = stickyHeaderTop + 45;
                    }
                    let stickyHeaderBottom = (stickyHeaderTop + section.offsetHeight) - 100;
                    if (window.scrollY < stickyHeaderTop) {
                        stickyHeader.classList.remove('product-grid__text-container--sticky');
                        stickyHeaderClone.classList.remove('product-grid__text-container__clone--sticky');
                    }
                    else if (!stickyHeader.classList.contains('product-grid__text-container--sticky') && window.scrollY > stickyHeaderTop) {
                        stickyHeader.classList.add('product-grid__text-container--sticky');
                        stickyHeaderClone.classList.add('product-grid__text-container__clone--sticky');
                    }
                    if (window.scrollY > stickyHeaderBottom) {
                        stickyHeaderClone.classList.add('product-grid__text-container__clone--sticky--hidden');
                    }
                    else {
                        stickyHeaderClone.classList.remove('product-grid__text-container__clone--sticky--hidden');
                    }
                });
            }
        });
    }
    document.addEventListener('shopify:section:load', (event) => {
        const sections = document.querySelectorAll('[data-section-type="product-grid"]');
        if (sections.length > 0) {
            [...sections].forEach((section) => {
                const { desktopCount, mobileCount, sectionId, mobileCarousel, desktopCarousel } = section.dataset;
                const slides = parseInt(section.dataset.tiles, 10);
                if (slides > 1) {
                    const swiperContainer = section.querySelector('[data-swiper-container]');
                    const swiperNext = `[data-section-id="${sectionId}"] .swiper-button-next`;
                    const swiperPrev = `[data-section-id="${sectionId}"] .swiper-button-prev`;
                    let extraSettings = {
                        navigation: {
                            nextEl: swiperNext,
                            prevEl: swiperPrev,
                            disabledClass: 'swiper-button--disabled',
                            hiddenClass: 'swiper-button--disabled',
                        },
                        scrollbar: {
                            el: '.swiper-scrollbar',
                            hide: false,
                        },
                        mousewheel: {
                            forceToAxis: true,
                        },
                        spaceBetween: 16,
                        breakpoints: {
                            0: {
                                enabled: mobileCarousel === 'true' ? true : false,
                                slidesPerView: mobileCount
                            },
                            1023: {
                                enabled: desktopCarousel === 'true' ? true : false,
                                slidesPerView: desktopCount
                            },
                        }
                    };
                    const carousel = new Carousel(swiperContainer, slides, swiperNext, swiperPrev, Number(desktopCount), Number(mobileCount), extraSettings);
                }
                let captionToggles = section.querySelectorAll('[data-caption-toggle]');
                if (captionToggles.length > 0) {
                    [...captionToggles].forEach((toggle, i) => {
                        toggle.addEventListener('click', (e) => {
                            e.preventDefault();
                            const caption = toggle.closest('.product-grid__product').querySelector('.product-grid__product--caption');
                            caption.classList.toggle('product-grid__product--caption-active');
                            toggle.classList.toggle('product-grid__product--caption-toggle--active');
                            if (caption.classList.contains('product-grid__product--caption-active')) {
                                let captionWrapper = toggle.closest('.product-grid__product--caption-toggle__wrapper');
                                ;
                                captionWrapper.style.marginBottom = 0 + 'px';
                            }
                            let validIndices = getCaptionsToToggle(i, Number(mobileCount), Number(desktopCount), mobileCarousel, desktopCarousel, section.dataset.tiles);
                            [...captionToggles].forEach((otherToggle, index) => {
                                if (otherToggle !== e.currentTarget && index >= validIndices[0] && index < validIndices[1]) {
                                    const otherCaption = otherToggle.closest('.product-grid__product').querySelector('.product-grid__product--caption');
                                    otherCaption.classList.remove('product-grid__product--caption-active');
                                    otherToggle.classList.remove('product-grid__product--caption-toggle--active');
                                    if (caption.classList.contains('product-grid__product--caption-active')) {
                                        let captionWrapper = otherToggle.closest('.product-grid__product--caption-toggle__wrapper');
                                        ;
                                        captionWrapper.style.marginBottom = caption.scrollHeight + 'px';
                                    }
                                    else if (!caption.classList.contains('product-grid__product--caption-active')) {
                                        let captionWrapper = otherToggle.closest('.product-grid__product--caption-toggle__wrapper');
                                        ;
                                        captionWrapper.style.marginBottom = '0px';
                                    }
                                }
                            });
                        });
                    });
                }
                let stickyHeader = section.querySelector('.product-grid__text-container');
                let stickyHeaderClone = section.querySelector('.product-grid__text-container__clone');
                if (stickyHeaderClone) {
                    window.addEventListener('scroll', () => {
                        let title = section.querySelector('.product-grid__title');
                        let subheader = section.querySelector('.product-grid__pre-heading');
                        let stickyHeaderTop = (title.offsetTop - 24 + (subheader ? 44 : 0)) - (stickyHeader.offsetHeight);
                        if (isMobile) {
                            stickyHeaderTop = stickyHeaderTop + 45;
                        }
                        let stickyHeaderBottom = (stickyHeaderTop + section.offsetHeight) - 100;
                        if (window.scrollY < stickyHeaderTop) {
                            stickyHeader.classList.remove('product-grid__text-container--sticky');
                            stickyHeaderClone.classList.remove('product-grid__text-container__clone--sticky');
                        }
                        else if (!stickyHeader.classList.contains('product-grid__text-container--sticky') && window.scrollY > stickyHeaderTop) {
                            stickyHeader.classList.add('product-grid__text-container--sticky');
                            stickyHeaderClone.classList.add('product-grid__text-container__clone--sticky');
                        }
                        if (window.scrollY > stickyHeaderBottom) {
                            stickyHeaderClone.classList.add('product-grid__text-container__clone--sticky--hidden');
                        }
                        else {
                            stickyHeaderClone.classList.remove('product-grid__text-container__clone--sticky--hidden');
                        }
                    });
                }
            });
        }
    });
});
